import { render, staticRenderFns } from "./manageParcel_kdy.vue?vue&type=template&id=10714ed6&scoped=true&"
import script from "./manageParcel_kdy.vue?vue&type=script&lang=js&"
export * from "./manageParcel_kdy.vue?vue&type=script&lang=js&"
import style0 from "./manageParcel_kdy.vue?vue&type=style&index=0&id=10714ed6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10714ed6",
  null
  
)

export default component.exports